import InlineSelect from '@components/atoms/inline-select/inline-select';
import { ListingContext } from '@context/listing.context';
import React, { useState, useEffect } from 'react';
import { useContextSelector } from 'use-context-selector';
import { useTranslation } from 'next-i18next';
import useWindowSize from '@hooks/use-window-size';
import styles from '../index.module.scss';
import CategoriesMenu from './categories-menu';

const CategoriesSelect: React.FC = () => {
  const { t } = useTranslation('pricing-calculator');
  const { isWiderThanMd } = useWindowSize();

  const DROPDOWN_HEIGHT = {
    padding: isWiderThanMd ? 26 : 18,
    item: isWiderThanMd ? 44 : 36,
  };

  const { categoryLabel, setPricingCalculatorInputTouched, setShowDefaultPricingCalculatorMessage } =
    useContextSelector(ListingContext, (state) => state);

  const [nbItemsDisplayed, setNbItemsDisplayed] = useState<number>(5);
  const [dropdownHeight, setDropdownHeight] = useState<number>(0);
  const [currentCategoryLabel, setCurrentCategoryLabel] = useState<string>(categoryLabel);
  const unselectedCategory = t('PRICING_CALCULATOR.CATEGORY_SELECTION.SELECT_LABEL_DEFAULT');
  const [closeMenu, setCloseMenu] = useState<boolean>(false);

  useEffect(() => {
    setCurrentCategoryLabel(categoryLabel !== '' ? categoryLabel : unselectedCategory);
  }, [categoryLabel]);

  useEffect(() => {
    setDropdownHeight(nbItemsDisplayed * DROPDOWN_HEIGHT.item + DROPDOWN_HEIGHT.padding);
  }, [nbItemsDisplayed]);

  return (
    <span className={styles.formSentence__text}>
      <InlineSelect
        selectedItemLabel={currentCategoryLabel}
        containerPosition="static"
        dropdownHeight={dropdownHeight}
        setIsTouched={setPricingCalculatorInputTouched}
        setMessageState={setShowDefaultPricingCalculatorMessage}
        closeMenu={closeMenu}
        setCloseMenu={setCloseMenu}
        typeName="category"
      >
        <CategoriesMenu
          setNbCatDisplayed={setNbItemsDisplayed}
          setCloseMenu={setCloseMenu}
        />
      </InlineSelect>
    </span>
  );
};

export default CategoriesSelect;
